import { LoaderContainer, Loader } from './style'

const ComponentLoader = () => {
  return (
    <LoaderContainer>
      <Loader />
    </LoaderContainer>
  )
}
export default ComponentLoader
